// extracted by mini-css-extract-plugin
module.exports = {"container":"Modale_container__37GPz","active":"Modale_active__3T80L","slide-left":"Modale_slide-left__hlp78"};